
import React, { useState } from "react";
import "./Average_Rating.css";
import Rating from "react-rating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
import { ProgressBar } from "react-bootstrap";
import Common_Btn_Yellow from "../../../../common-components/common_btn_yellow/Common_Btn_Yellow";
import Submit_Your_Review from "../submit_Your_Review/Submit_Your_Review";

function Average_Rating({ avg_rating, doctor }) {
  const [showReviewModal, setShowReviewModal] = useState(false);

  return (
    <section className="Average_Rating">
      <div className="rating_card">
        <div className="score_box">
          <p className="score_title">Customer Rating</p>

          <h2 className="score_value">
            {Number(avg_rating?.average_rating || 0).toFixed(1)}
            <span className="score_total">/ 5.0</span>
          </h2>

          <Rating
            className="score_stars"
            initialRating={Number(avg_rating?.average_rating || 0)}
            emptySymbol={
              <FontAwesomeIcon icon={farStar} color="#f4b400" />
            }
            fullSymbol={
              <FontAwesomeIcon icon={fasStar} color="#f4b400" />
            }
            fractions={2}
            readonly
          />

          <p className="score_count">
            Based on {avg_rating?.total_counts || 0} Reviews
          </p>
        </div>

        <div className="rating_breakdown">
          {avg_rating?.rating_counts?.map((rating, index) => (
            <div className="rating_row" key={index}>
              <span className="star_label">
                {rating.name}
                <FontAwesomeIcon
                  icon={fasStar}
                  className="star_icon"
                />
              </span>

              <ProgressBar
                now={Math.min(
                  100,
                  Math.max(0, Number(rating.percentage) || 0)
                )}
                className="custom_progress"
              />

              <span className="percent_label">
                {Math.round(Number(rating.percentage) || 0)}%
              </span>
            </div>
          ))}
        </div>

        <div className="review_box">
          <h5 className="review_title">Review this doctor</h5>

          <p className="review_text">
            Share your experience with other patients
          </p>

          <Common_Btn_Yellow
            text="Write a Review"
            onClick={() => setShowReviewModal(true)}
          />
        </div>
      </div>

      <Submit_Your_Review
        show={showReviewModal}
        onHide={() => setShowReviewModal(false)}
        doctor={doctor}
      />
    </section>
  );
}

export default Average_Rating;
